export const currentUser = (state) => state.user

export const currentUserIsBot = (state) => currentUser(state)?.bot ?? false
